export const StartingChip = (): JSX.Element => (
  <div className="flex w-fit items-center rounded-full bg-white/20 px-3 py-1 text-center text-sm text-white">
    Starting
  </div>
);
